import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ReadonlyHttpApiCollectionRepository, Result } from '@softline/core';
import { SOFTLINE_API_BELEGARTEN } from '../gesamtabfrage.api';
import { Belegart } from '@softapps/wws/gesamtabfrage/api';

@Injectable()
export class BelegartRepository extends ReadonlyHttpApiCollectionRepository<Result<Belegart[]>> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_BELEGARTEN);
  }
}
